var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationsStationsBig = function SvgLocationsStationsBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "Locations&Stations_big",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3870"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.269 20.632a.429.429 0 0 1-.3-.117c-.273-.262-6.684-6.436-6.684-11.551a6.987 6.987 0 0 1 13.959 0c0 5.116-6.41 11.291-6.683 11.551a.429.429 0 0 1-.292.117zm0-17.529a6.013 6.013 0 0 0-6.141 5.86c0 4.184 4.876 9.407 6.141 10.691 1.266-1.284 6.141-6.5 6.141-10.691a6.014 6.014 0 0 0-6.141-5.858zm0 9.52a3.663 3.663 0 1 1 3.835-3.66 3.754 3.754 0 0 1-3.835 3.66zm0-6.519a2.863 2.863 0 1 0 3 2.859 2.933 2.933 0 0 0-3-2.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M2 2.303h18.329v18.329H2z",
    "data-name": "Rectangle 4475"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.693 19.259H4.838a2.847 2.847 0 0 1-2.84-2.846 2.842 2.842 0 0 1 2.84-2.84h3.447l-.217.178c-.227.183.564.393.375.614l-.033.033H4.838a2.023 2.023 0 0 0-2.016 2.015 2.019 2.019 0 0 0 2.016 2.016h6.955l1 .83zm-5.951-2.846a.591.591 0 0 1 .592-.586.591.591 0 0 1 .588.586.587.587 0 0 1-.588.587.588.588 0 0 1-.592-.585zm-3.172 0a.586.586 0 0 1 .586-.586.591.591 0 0 1 .588.586.587.587 0 0 1-.588.587.583.583 0 0 1-.586-.585zm.561-3.426V8.868h2.51l1.428 4.119zm.824-.825h2.682l-.895-2.463H4.955z",
    "data-name": "Path 11641"
  }))));
};
export default SvgLocationsStationsBig;